module.exports = __webpack_public_path__ + "static/media/badminton.6c533144.png";